import { useQuery } from '@tanstack/react-query'
import { teamApi } from '@/api/team'

export const teamKeys = {
  all: ['team'] as const,
  workload: () => [...teamKeys.all, 'workload'] as const,
  timeSummary: (from?: string, to?: string) => [...teamKeys.all, 'timeSummary', from, to] as const,
}

export function useTeamWorkload() {
  return useQuery({
    queryKey: teamKeys.workload(),
    queryFn: () => teamApi.workload(),
  })
}

export function useTeamTimeSummary(from_date?: string, to_date?: string) {
  return useQuery({
    queryKey: teamKeys.timeSummary(from_date, to_date),
    queryFn: () => teamApi.timeSummary(from_date, to_date),
  })
}
